import React from 'react'
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaGithub } from 'react-icons/fa'
import { animateScroll as scroll } from 'react-scroll'

import img1 from '../../images/favicon.png'

const Footer = () => {
  const toggleHome = () => {
    scroll.scrollToTop();
  }

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-links">
          <div className="footer-column">
            <h6>Product</h6>
            <ul>
              <li><a href="/admin/dashboard">Dashboard</a></li>
              <li><a href="/admin/wallet">Transactions</a></li>
              <li><a href="/admin/scan">Receipt Scanner</a></li>
              <li><a href="/admin/goals">Financial Goals</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h6>Company</h6>
            <ul>
              <li><a href="/home">About</a></li>
              <li><a href="#features">Features</a></li>
              <li><a href="/signin">Sign In</a></li>
              <li><a href="/signup">Get Started</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-brand">Finova</div>
          <p>© {new Date().getFullYear()} Finova. All rights reserved.</p>
          <p>Built with <a href="https://webmentors.in" target="_blank" rel="noopener noreferrer">Webmentors</a></p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
